import axios from 'axios';

const client = axios.create({
    baseURL: `${import.meta.env.VITE_APP_BELOZ_V2_ENDPOINT}/public/web/application`,
    headers: {
        'Content-Type': 'application/json',
        'beloz-api-key': import.meta.env.VITE_PUBLIC_BELOZ_V2_API_KEY,
    },
    timeout: 30000,
});


export async function validateCurpService(curp) {
    try {
        let { data } = await client.post(
            '/curp/validation',
            {
                curp,
            },
        );
        return data;
    } catch (err) {
        console.log(err);
        return {
            success: false,
        };
    }
}

export async function fetchDuplicatedUserDetailsByCurpService(curp) {
    try {
        let {data} = await client.get(`/curp/${curp}`);
        return data;
    } catch (err) {
        console.log(err);
        return {
            success: false,
        };
    }
}

export async function fetchUserOccupations() {
    try {
        let { data } = await client.get('/user-occupation');
        return {
            success: data.success,
            occupations: data.data,
        };
    } catch (error) {
        return {
            success: false,
        };
    }
}


export async function fetchLoanUsages() {
    try {
        let { data } = await client.get('/loan-usage');
        return {
            success: data.success,
            usages: data.data,
        };
    } catch (error) {
        return {
            success: false,
        };
    }
}


export async function getZipCodeInfo(zipCode) {
    try {
        let { data } = await client.get(
            `/zip-code-info/${zipCode}`
        );
        return data;
    } catch (err) {
        console.log(err);
        return {
            success: false,
        };
    }
}

